<template>
  <div id="app">
    <NavBar :image-path="require('./assets/SecureSecretsBannerLogo.png')" />
    <div class="contentContainer">
      <router-view />
    </div>
    <Footer
      :company-name="companyName"
      :internal-footer-links="internalFooterLinks"
      :external-footer-links="externalFooterLinks"
      :copyright-year="copyrightYear"
      :privacy-policy="privacyPolicy"
    />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default {
  components: {
    NavBar,
    Footer,
  },
  name: "app",

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Secure Secrets",
    // all titles will be injected into this template
    titleTemplate: "%s | Secure Secrets",
  },

  data: () => ({
    companyName: "Secure Secrets",

    internalFooterLinks: [
      {
        headingText: "Secure Secrets",
        linkData: [
          {
            text: "About",
            path: "/",
          },
          {
            text: "Staking ROI Calculator",
            path: "/stakingcalculator",
          },
          {
            text: "Validator ROI Calculator",
            path: "/validatorcalculator",
          },
          {
            text: "Secret Network Gray Paper",
            path: "/papers",
          },
          {
            text: "Community",
            path: "/community",
          },
        ],
      },
      {
        headingText: "Services",
        linkData: [
          {
            text: "Staking",
            path: "/#",
          },
          {
            text: "Newsletter",
            path: "/#newsletter",
          },
        ],
      },
    ],
    externalFooterLinks: {
      headingText: "Contact",
      linkData: [
        {
          //  Telegram
          path: "https://t.me/securesecrets",
          symbol: "fab fa-telegram fa-lg",
        },
        {
          //  Discord
          path: "https://discord.gg/tXj3tCH",
          symbol: "fab fa-discord fa-lg",
        },
        {
          //  Twitter
          path: "https://twitter.com/securesecrets",
          symbol: "fab fa-twitter fa-lg",
        },
        {
          //  Youtube
          path: "https://www.youtube.com/c/SecureSecrets",
          symbol: "fab fa-youtube fa-lg",
        },
        {
          //  LinkedIn
          path: "https://www.linkedin.com/company/securesecrets",
          symbol: "fab fa-linkedin fa-lg",
        },
        {
          //  Medium
          path: "https://securesecrets-org.medium.com/",
          symbol: "fab fa-medium fa-lg",
        },
      ],
    },
    copyrightYear: "2021",
    privacyPolicy: {
      text: "Privacy Policy",
      path: "/privacypolicy",
    },
  }),
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
@import "https://unpkg.com/ionicons@4.2.2/dist/css/ionicons.min.css";

figure {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 10px;
  margin-inline-end: 0;
}

body {
  margin: 0;
}

#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #141a3c;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #141a3c;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.contentContainer {
  max-width: 1500px;
  margin: 0 auto;
  padding-bottom: 30px;
}
</style>
